import { render } from "./TextAnnotatorWidget.vue?vue&type=template&id=64dc2fa4&scoped=true"
import script from "./TextAnnotatorWidget.vue?vue&type=script&lang=js"
export * from "./TextAnnotatorWidget.vue?vue&type=script&lang=js"

import "./TextAnnotatorWidget.vue?vue&type=style&index=0&id=64dc2fa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dc2fa4"]])

export default __exports__